import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div>
      <div className="tm-footer">
        <div className="tm-section tm-feature-area bg-grey feature-area-one">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-4 shipping-text">
                <div className="tm-feature">
                  <span className="tm-feature-icon">
                    <img
                      src="assets/images/icons/icon-free-shipping.png"
                      alt="free shipping"
                    />
                  </span>
                  <div className="tm-feature-content">
                    <h6>{t("freeshipping")}</h6>
                    <p>{t("freeshippingcontent")}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 shipping-text2">
                <div className="tm-feature">
                  <span className="tm-feature-icon">
                    <img
                      src="assets/images/icons/icon-fast-delivery.png"
                      alt="fast delivery"
                    />
                  </span>
                  <div className="tm-feature-content">
                    <h6>{t("fastdelivery")}</h6>
                    <p>{t("fastdeliverycontent")}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 shipping-text">
                <div className="tm-feature">
                  <span className="tm-feature-icon">
                    <img
                      src="assets/images/icons/icon-247-support.png"
                      alt="24/7 Support"
                    />
                  </span>
                  <div className="tm-feature-content">
                    <h6>{t("suport")}</h6>
                    <p>{t("suportcontent")} </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ul id="instafeed" className="tm-instaphotos" />
        <div className="tm-footer-toparea tm-padding-section">
          <div className="container">
            <div
              className="widgets widgets-footer row"
              style={{ boxShadow: "none" }}
            >
              <div className="col-lg-3 col-md-6 col-12 footer-logomobile">
                <div className="single-widget widget-info">
                  <a className="widget-info-logo">
                    <Link
                      to="/Home"
                      onClick={handleLinkClick}
                      className="tm-header-logo"
                    >
                      <img src="assets/images/logo.png" alt="logo" />
                    </Link>
                  </a>
                  <p>{t("footercontent")}</p>
                  <div className="social-icons">
                    <a title="facebook">
                      <i className="fa fa-facebook-square" aria-hidden="true" />
                    </a>
                    <a title="twitter">
                      <i className="fa fa-twitter-square" aria-hidden="true" />
                    </a>
                    <a title="instagram">
                      <i className="fa fa-instagram" aria-hidden="true" />
                    </a>
                    <a title="youtube">
                      <i className="fa fa-youtube-square" aria-hidden="true" />
                    </a>
                    <a title="linkedin">
                      <i className="fa fa-linkedin-square" aria-hidden="true" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-12">
                <div className="single-widget widget-quicklinks">
                  <h6 className="widget-title widget-title-one">
                    {t("usefullink")}
                  </h6>
                  <ul>
                    <li>
                      {/* <Link to="/About" onClick={handleLinkClick}>
                        {t("Aboutus")}
                      </Link> */}
                      <Link to="/products" onClick={handleLinkClick}>
                        {t("Category")}
                      </Link>
                      <Link to="/contact" onClick={handleLinkClick}>
                        {t("Contact")}
                      </Link>
                      <Link to="/privacy-policy" onClick={handleLinkClick}>
                        {t("Privacy_policy")}
                      </Link>
                      <Link to="/Termcond" onClick={handleLinkClick}>
                        {t("Term_cond")}
                      </Link>
                      <Link to="/Refunds" onClick={handleLinkClick}>
                        {t("Refund")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-12">
                <div className="single-widget widget-quicklinks">
                  <h6 className="widget-title widget-title-one">
                    {" "}
                    {t("Myaccount")}
                  </h6>
                  <ul>
                    <li>
                      <Link to="/Cart" onClick={handleLinkClick}>
                    {t("cart")}
                        
                      </Link>
                      <Link to="/Blog" onClick={handleLinkClick}>
                      {t("footerBlog")}

                      </Link>
                      <Link to="/Wishlist" onClick={handleLinkClick}>
                      {t("Wishlist")}

                      </Link>
                      <Link to="/Myprofile" onClick={handleLinkClick}>
                      {t("Myprofile")}

                      </Link>
                      <Link to="/Checkout" onClick={handleLinkClick}>
                      {t("Checkout")}

                      </Link>
                      {/* <Link to="/Blogdetails" onClick={handleLinkClick}>
                      {t("Blogdetails")}

                      </Link> */}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-5 col-12">
                <div className="single-widget widget-newsletter">
                  <h6 className="widget-title widget-title-one">
                  {t("Keepintouch")}

                  </h6>
                  <ul style={{ marginBottom: 10 }}>
                    <li className="map-marker2">
                      <i className="fa fa-phone" />
                      <a href="tel:+9999999999"> +91 9999999999</a>
                    </li>
                    <li>
                      <i className="fa fa-envelope" />
                      <a href="mailto:info@jewellery.com">
                        {" "}
                        info@khomefashion.com
                      </a>
                    </li>
                    <li className="map-marker1">
                      <i className="fa fa-map-marker fo-sm" /> {t("jaipur")}{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tm-footer-bottomarea">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-7">
                <p className="tm-footer-copyright">
                 
                  <a href="https://satellitekeyit.com/">
                  {t("SK")}{" "}
                  </a>
                </p>
              </div>
              <div className="col-md-5">
                <div className="tm-footer-payment">
                  <img
                    alt="payment methods"
                    src="assets/images/payment-methods.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="tm-product-quickview" id="tm-product-quickview">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-9 col-lg-10 col-12">
              <div className="tm-product-quickview-inner">
                <div className="tm-prodetails">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-10 col-12">
                      <div className="tm-prodetails-images">
                        <div className="tm-prodetails-largeimages">
                          <div className="tm-prodetails-largeimage">
                            <img
                              data-pagespeed-lazy-src="assets/images/products/product-image-1.jpg"
                              alt="product image"
                              src="pagespeed_static/1.JiBnMqyl6S.gif"
                              onload="pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                              onerror="this.onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                            />
                          </div>
                          <div className="tm-prodetails-largeimage">
                            <img
                              data-pagespeed-lazy-src="assets/images/products/product-image-2.jpg"
                              alt="product image"
                              src="pagespeed_static/1.JiBnMqyl6S.gif"
                              onload="pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                              onerror="this.onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                            />
                          </div>
                          <div className="tm-prodetails-largeimage">
                            <img
                              data-pagespeed-lazy-src="assets/images/products/product-image-3.jpg"
                              alt="product image"
                              src="pagespeed_static/1.JiBnMqyl6S.gif"
                              onload="pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                              onerror="this.onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                            />
                          </div>
                          <div className="tm-prodetails-largeimage">
                            <img
                              data-pagespeed-lazy-src="assets/images/products/product-image-4.jpg"
                              alt="product image"
                              src="pagespeed_static/1.JiBnMqyl6S.gif"
                              onload="pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                              onerror="this.onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                            />
                          </div>
                          <div className="tm-prodetails-largeimage">
                            <img
                              data-pagespeed-lazy-src="assets/images/products/product-image-6.jpg"
                              alt="product image"
                              src="pagespeed_static/1.JiBnMqyl6S.gif"
                              onload="pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                              onerror="this.onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                            />
                          </div>
                          <div className="tm-prodetails-largeimage">
                            <img
                              data-pagespeed-lazy-src="assets/images/products/product-image-6.jpg"
                              alt="product image"
                              src="pagespeed_static/1.JiBnMqyl6S.gif"
                              onload="pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                              onerror="this.onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                            />
                          </div>
                        </div>
                        <div className="tm-prodetails-thumbnails">
                          <div className="tm-prodetails-thumbnail">
                            <img
                              data-pagespeed-lazy-src="assets/images/products/product-image-1-thumb.jpg"
                              alt="product image"
                              src="pagespeed_static/1.JiBnMqyl6S.gif"
                              onload="pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                              onerror="this.onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                            />
                          </div>
                          <div className="tm-prodetails-thumbnail">
                            <img
                              data-pagespeed-lazy-src="assets/images/products/product-image-2-thumb.jpg"
                              alt="product image"
                              src="pagespeed_static/1.JiBnMqyl6S.gif"
                              onload="pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                              onerror="this.onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                            />
                          </div>
                          <div className="tm-prodetails-thumbnail">
                            <img
                              data-pagespeed-lazy-src="assets/images/products/product-image-3-thumb.jpg"
                              alt="product image"
                              src="pagespeed_static/1.JiBnMqyl6S.gif"
                              onload="pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                              onerror="this.onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                            />
                          </div>
                          <div className="tm-prodetails-thumbnail">
                            <img
                              data-pagespeed-lazy-src="assets/images/products/product-image-4-thumb.jpg"
                              alt="product image"
                              src="pagespeed_static/1.JiBnMqyl6S.gif"
                              onload="pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                              onerror="this.onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                            />
                          </div>
                          <div className="tm-prodetails-thumbnail">
                            <img
                              data-pagespeed-lazy-src="assets/images/products/product-image-5-thumb.jpg"
                              alt="product image"
                              src="pagespeed_static/1.JiBnMqyl6S.gif"
                              onload="pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                              onerror="this.onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                            />
                          </div>
                          <div className="tm-prodetails-thumbnail">
                            <img
                              data-pagespeed-lazy-src="assets/images/products/product-image-6-thumb.jpg"
                              alt="product image"
                              src="pagespeed_static/1.JiBnMqyl6S.gif"
                              onload="pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                              onerror="this.onerror=null;pagespeed.lazyLoadImages.loadIfVisibleAndMaybeBeacon(this);"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <div className="tm-prodetails-content">
                        <h4 className="tm-prodetails-title">
                          Stylist daimond ring
                        </h4>
                        <span className="tm-prodetails-price">
                          <del>₹ 75.99</del> ₹ 59.99
                        </span>
                        <div
                          id="starrat"
                          className="tm-ratingbox ratingbox-one starrate"
                          data-val="2.5"
                          data-max={5}
                        >
                          <a href="product-details.html">
                            <span className="is-active-one">4.5</span>
                            <span>
                              <i className="ion-android-star-outline star-outline-one" />
                            </span>
                          </a>
                        </div>
                        <div className="tm-prodetails-infos">
                          <div className="tm-prodetails-singleinfo">
                            <b>Product ID : </b>010
                          </div>
                          <div className="tm-prodetails-singleinfo">
                            <b>Category : </b>
                            <a href="#">Ring</a>
                          </div>
                          <div className="tm-prodetails-singleinfo tm-prodetails-tags">
                            <b>Tags : </b>
                            <ul>
                              <li>
                                <a href="#">bracelets</a>
                              </li>
                              <li>
                                <a href="#">diamond</a>
                              </li>
                              <li>
                                <a href="#">ring</a>
                              </li>
                              <li>
                                <a href="#">necklaces</a>
                              </li>
                            </ul>
                          </div>
                          <div className="tm-prodetails-singleinfo">
                            <b>Available : </b>
                            <span className="color-theme">In Stock</span>
                          </div>
                          <div className="tm-prodetails-singleinfo tm-prodetails-share">
                            <b>Share : </b>
                            <ul>
                              <li>
                                <i className="ion-social-facebook" />
                              </li>
                              <li>
                                <a href="#">
                                  <i className="ion-social-instagram-outline" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="ion-social-skype-outline" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="ion-social-pinterest-outline" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Quis quemi dolor, malesuada id metus a, mattis
                          eleifend elit. Nullam pharetra consequat ex in
                          dapibus. Vestibulum ante ipsum primis in faucibus
                          orciluctus curae.
                        </p>
                        <div className="tm-prodetails-quantitycart">
                          <h6>Quantity :</h6>
                          <div className="tm-quantitybox">
                            <input type="text" defaultValue={1} />
                          </div>
                          <a href="#" className="tm-button tm-button-dark">
                            Add To Cart
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <button id="back-top-top"><i className="ion-arrow-up-c" /></button> */}
    </div>
  );
};

export default Footer;
